import {ReactNode, useEffect, useMemo, useRef, useState} from "react";
import type {ActionMeta, SingleValue} from "react-select";

import {Modal} from "@pg-design/modal-module";
import {Radio} from "@pg-design/radio";
import type {ISelectProps} from "@pg-design/select-module";
import {Select} from "@pg-design/select-module";

import {
    getLangSelectComponents,
    getLangSelectStyles,
    getLangSelectTheme,
    ILangSelectComponents,
    ILangSelectOption,
    ILangSelectStyles
} from "./lang_select_dark_theme";

import * as styles from "./LangSelect.module.css";

interface ILangSelectProps extends Omit<ISelectProps, "onChange" | "isMulti" | "value" | "options" | "styles" | "components"> {
    radioName: string;
    options: ILangSelectOption[];
    isMobile: boolean;
    initialValue?: ILangSelectOption["value"];
    modalLabel?: ReactNode;
    onChange?: (newValue: ILangSelectOption, actionMeta: ActionMeta<ILangSelectOption>) => void;
    styles?: ILangSelectStyles;
    components?: ILangSelectComponents;
}

type ILangSelectValue = ILangSelectOption["value"] | undefined;

export function LangSelect(props: ILangSelectProps) {
    const {
        isMobile,
        modalLabel,
        radioName,
        initialValue,
        onChange,
        onMenuOpen,
        options,
        styles: userStyles,
        components: userComponents,
        ...selectProps
    } = props;

    const [isModalOpened, setIsModalOpened] = useState(false);
    const [selectValue, setSelectValue] = useState<ILangSelectValue>(initialValue);
    const prevSelectValueRef = useRef(initialValue);

    const selectedValue = options.find((option) => option.value === selectValue);

    useEffect(() => {
        if (selectedValue && onChange && prevSelectValueRef.current !== selectedValue.value) {
            const actionMeta: ActionMeta<ILangSelectOption> = {action: "select-option", option: undefined};

            prevSelectValueRef.current = selectedValue.value;
            onChange(selectedValue, actionMeta);
        }
    }, [selectValue]);

    const applySelectionAndCloseModal = (value: ILangSelectValue) => {
        setSelectValue(value);
        setIsModalOpened(false);
    };

    const selectStyles = useMemo(() => getLangSelectStyles(userStyles, isMobile), [isMobile, userStyles]);

    const selectComponents = useMemo(() => getLangSelectComponents({isMobile, radioName, userComponents}), [isMobile, radioName, userComponents]);

    const langSelectProps = {
        ...selectProps,
        theme: getLangSelectTheme,
        options,
        components: selectComponents,
        styles: selectStyles,
        value: selectedValue,
        onChange: (newValue: SingleValue<ILangSelectOption>) => {
            if (newValue) setSelectValue(newValue.value);
        },
        menuIsOpen: isMobile ? false : undefined,
        onMenuOpen: () => {
            if (isMobile) setIsModalOpened(true);
            if (!isMobile && onMenuOpen) onMenuOpen();
        }
    };

    return (
        <>
            <Select {...(langSelectProps as ISelectProps)} />

            {isMobile && (
                <Modal fullScreen isOpen={isModalOpened} onModalClose={() => setIsModalOpened(false)}>
                    <Modal.Header variant="bar_mini">{modalLabel ? modalLabel : " "}</Modal.Header>

                    <Modal.Content className={styles.modalContent}>
                        <ul className={styles.optionList}>
                            {options.map((option) => (
                                <li key={`lsk_${option.value}`} className={styles.optionListItem}>
                                    <Radio
                                        id={`lsid_${option.value}`}
                                        name={radioName}
                                        value={option.value}
                                        isActive={selectValue === option.value}
                                        iconFill="var(--colors-secondary)"
                                        labelContent={<>{option.label}</>}
                                        onChange={() => applySelectionAndCloseModal(option.value)}
                                    />
                                </li>
                            ))}
                        </ul>
                    </Modal.Content>
                </Modal>
            )}
        </>
    );
}
import {ReactNode, useEffect, useMemo, useRef, useState} from "react";
import type {ActionMeta, SingleValue} from "react-select";

import {Modal} from "@pg-design/modal-module";
import {Radio} from "@pg-design/radio";
import type {ISelectProps} from "@pg-design/select-module";
import {Select} from "@pg-design/select-module";

import {
    getLangSelectComponents,
    getLangSelectStyles,
    getLangSelectTheme,
    ILangSelectComponents,
    ILangSelectOption,
    ILangSelectStyles
} from "./lang_select_dark_theme";

import * as styles from "./LangSelect.module.css";

interface ILangSelectProps extends Omit<ISelectProps, "onChange" | "isMulti" | "value" | "options" | "styles" | "components"> {
    radioName: string;
    options: ILangSelectOption[];
    isMobile: boolean;
    initialValue?: ILangSelectOption["value"];
    modalLabel?: ReactNode;
    onChange?: (newValue: ILangSelectOption, actionMeta: ActionMeta<ILangSelectOption>) => void;
    styles?: ILangSelectStyles;
    components?: ILangSelectComponents;
}

type ILangSelectValue = ILangSelectOption["value"] | undefined;

export function LangSelect(props: ILangSelectProps) {
    const {
        isMobile,
        modalLabel,
        radioName,
        initialValue,
        onChange,
        onMenuOpen,
        options,
        styles: userStyles,
        components: userComponents,
        ...selectProps
    } = props;

    const [isModalOpened, setIsModalOpened] = useState(false);
    const [selectValue, setSelectValue] = useState<ILangSelectValue>(initialValue);
    const prevSelectValueRef = useRef(initialValue);

    const selectedValue = options.find((option) => option.value === selectValue);

    useEffect(() => {
        if (selectedValue && onChange && prevSelectValueRef.current !== selectedValue.value) {
            const actionMeta: ActionMeta<ILangSelectOption> = {action: "select-option", option: undefined};

            prevSelectValueRef.current = selectedValue.value;
            onChange(selectedValue, actionMeta);
        }
    }, [selectValue]);

    const applySelectionAndCloseModal = (value: ILangSelectValue) => {
        setSelectValue(value);
        setIsModalOpened(false);
    };

    const selectStyles = useMemo(() => getLangSelectStyles(userStyles, isMobile), [isMobile, userStyles]);

    const selectComponents = useMemo(() => getLangSelectComponents({isMobile, radioName, userComponents}), [isMobile, radioName, userComponents]);

    const langSelectProps = {
        ...selectProps,
        theme: getLangSelectTheme,
        options,
        components: selectComponents,
        styles: selectStyles,
        value: selectedValue,
        onChange: (newValue: SingleValue<ILangSelectOption>) => {
            if (newValue) setSelectValue(newValue.value);
        },
        menuIsOpen: isMobile ? false : undefined,
        onMenuOpen: () => {
            if (isMobile) setIsModalOpened(true);
            if (!isMobile && onMenuOpen) onMenuOpen();
        }
    };

    return (
        <>
            <Select {...(langSelectProps as ISelectProps)} />

            {isMobile && (
                <Modal fullScreen isOpen={isModalOpened} onModalClose={() => setIsModalOpened(false)}>
                    <Modal.Header variant="bar_mini">{modalLabel ? modalLabel : " "}</Modal.Header>

                    <Modal.Content className={styles.modalContent}>
                        <ul className={styles.optionList}>
                            {options.map((option) => (
                                <li key={`lsk_${option.value}`} className={styles.optionListItem}>
                                    <Radio
                                        id={`lsid_${option.value}`}
                                        name={radioName}
                                        value={option.value}
                                        isActive={selectValue === option.value}
                                        iconFill="var(--colors-secondary)"
                                        labelContent={<>{option.label}</>}
                                        onChange={() => applySelectionAndCloseModal(option.value)}
                                    />
                                </li>
                            ))}
                        </ul>
                    </Modal.Content>
                </Modal>
            )}
        </>
    );
}
